import React, { useEffect, useState, useContext } from "react";
import { Card, CardHeader } from "@mui/material";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import AccountingApi from "../../../Classes/API/AccountingApi";
import Swal from "sweetalert2";
import CreateContractReq from "../../../Classes/Models/Requests/Accounting/CreateContractReq";
import { LanguageContext } from "App";
import { useNavigate } from "react-router-dom";
import SessionSelectionPopup from "./SessionSelectionPopup";

const Index = () => {
  const navigate = useNavigate();
  const { translations } = useContext(LanguageContext);

  const [Name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [showSessionPopup, setShowSessionPopup] = useState(false);
  const [selectedSessions, setSelectedSessions] = useState([]);


  const handleSessionsSelected = (sessionIds) => {
    setSelectedSessions(sessionIds);
    // After sessions are selected, proceed with contract creation
    createContract(sessionIds);
  };

  const onCreateClick = async () => {
    if (!Name || !Description) {
      Swal.fire({
        title: "Error",
        text: "Please enter Contract Name and Description",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    // Show the session selection popup instead of creating immediately
    setShowSessionPopup(true);
  };

  const createContract = async (sessionIds) => {
    try {
      let req = new CreateContractReq();

      req.Name = Name;
      req.Description = Description;
      req.SelectedSessionIds = sessionIds;

      let res = await AccountingApi.CreateContract(req);
      if (res.status == "Success") {
        Swal.fire({
          title: "Success",
          text: res.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/ContractTable/Details", { state: { SearchContract: res.data } });
        });
      } else {
        Swal.fire({
          title: "Error",
          text: res.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Failed to create contract:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to create contract",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card sx={{ padding: "2em" }}>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.sidebarChildernAccountingCreateContract}
          </MDTypography>
          <div>
            <MDButton
              type="button"
              sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
              color="text"
              onClick={() => onCreateClick()}
            >
              + {translations.CreateDomesticStayCreate}
            </MDButton>
          </div>
        </MDBox>

        <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 mt-3">
                <MDInput
                  sx={{ width: "100%" }}
                  label={translations.CreateContractContractName}
                  onChange={(e) => setName(e.target.value)}
                  type={"text"}
                  fullWidth
                ></MDInput>
              </div>

              <div className="col-md-4 mt-3">
                <MDInput
                  sx={{ width: "100%" }}
                  label={translations.CreateContractDescription}
                  onChange={(e) => setDescription(e.target.value)}
                  type={"text"}
                  fullWidth
                ></MDInput>
              </div>
            </div>

            {selectedSessions.length > 0 && (
              <div className="row mt-3">
                <div className="col-md-8">
                  <MDTypography variant="body2" color="info">
                    {selectedSessions.length} session(s) selected for this contract
                  </MDTypography>
                </div>
              </div>
            )}
          </div>
        </div>
      </Card>

      {/* Session Selection Popup */}
      <SessionSelectionPopup
        open={showSessionPopup}
        onClose={() => setShowSessionPopup(false)}
        onSessionsSelected={handleSessionsSelected}
      />
    </DashboardLayout>
  );
};

export default Index;
